import React from "react";
import { Box, Typography, makeStyles, useMediaQuery } from "@material-ui/core";

import {colorSecondary, colorAdditional, colorWhite, colorTextAdditional, colorPrimary } from "../../../Constants/theme";

interface Props {
	setUserType: React.Dispatch<React.SetStateAction<"user" | "vet">>,
	userType: string,
}

const useStyles = makeStyles({
    box: {
        cursor: "pointer",
    }
});

const UserTypeRadio: React.FunctionComponent<Props> = ({setUserType, userType}: Props) => {
    const classes = useStyles();
    const desktopResolution = useMediaQuery("(min-width:555px)");
    return(
        <Box
            display="flex" 
            justifyContent="center"
            width="100%"
            marginBottom="28"
            flexDirection={desktopResolution ? "row" : "column"}
        >
            <Box
                padding="14px 43px"
                bgcolor={userType === "user" ? colorPrimary : colorWhite}
                color={userType === "user" ? colorWhite : colorPrimary}
                border={`1.5px solid ${colorPrimary}`}
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                className={classes.box}
                width={desktopResolution ? "50%" : "100%"}
                onClick={() => {setUserType("user");}}
                borderRadius={desktopResolution ? "5px 0 0 5px" : "0 0 0 0"}
                marginBottom={desktopResolution ? "0" : "5px"}
            >
                <Typography
                    color="inherit"
                    style={userType === "user" ? {fontWeight: 600} : {}}
                >
					I am a Pet Parent
                </Typography>
            </Box>
            <Box
                padding="14px 43px"
                bgcolor={userType === "vet" ? colorPrimary : colorWhite}
                color={userType === "vet" ? colorWhite : colorPrimary}
                border={`1.5px solid ${colorPrimary}`}
                width={desktopResolution ? "50%" : "100%"}
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                className={classes.box}
                onClick={() => setUserType("vet")}
                borderRadius={desktopResolution ? "0 5px 5px 0" : "0"}
            >
                <Typography
                    color="inherit"
                    style={userType === "vet" ? {fontWeight: 600} : {}}
                >
					I am a Veterinarian
                </Typography>
            </Box>
        </Box>
    );
};

export default UserTypeRadio;
